"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRewardWithdrawalMsg = void 0;
const codec_1 = require("../codec");
const tx_1 = require("cosmjs-types/cosmos/distribution/v1beta1/tx");
const getRewardWithdrawalMsg = (walletAddress, denom, validatorAddress, delegatorAddress) => {
    if (denom === "swth") {
        return {
            typeUrl: codec_1.TxTypes.MsgWithdrawDelegatorReward,
            value: tx_1.MsgWithdrawDelegatorReward.fromPartial({
                delegatorAddress: delegatorAddress !== null && delegatorAddress !== void 0 ? delegatorAddress : walletAddress,
                validatorAddress: validatorAddress,
            }),
        };
    }
    else {
        return {
            typeUrl: codec_1.TxTypes.MsgAllianceClaimDelegationRewards,
            value: codec_1.Carbon.Alliance.MsgClaimDelegationRewards.fromPartial({
                delegatorAddress: delegatorAddress !== null && delegatorAddress !== void 0 ? delegatorAddress : walletAddress,
                validatorAddress: validatorAddress,
                denom: denom,
            }),
        };
    }
};
exports.getRewardWithdrawalMsg = getRewardWithdrawalMsg;
